// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.atp-video-container {
  width: calc(50% - 35px);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 32px;
  margin-left: 35px;
  position: relative;
  border-radius: 32px;
  overflow: hidden;
}
.atp-video-container video {
  border-radius: 32px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.atp-video-container .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
}
.atp-video-container .video-title {
  color: #fff;
  font-size: 26px;
  font-weight: 300;
  text-align: center;
  width: 100%;
  padding-top: 40px;
}
.atp-video-container .custom-play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  border: none;
  background: none;
  outline: none;
}
.atp-video-container .custom-play-button img {
  width: 50px;
  height: auto;
}
.atp-video-container.playing .overlay, .atp-video-container.playing .custom-play-button {
  display: none;
}
.atp-video-container .hidden {
  display: none;
}

@media only screen and (min-width: 0px) and (max-width: 1024px) {
  .atp-video-container {
    margin-left: 16px;
    width: calc(50% - 16px);
  }
}
@media only screen and (min-width: 0px) and (max-width: 768px) {
  .atp-video-container {
    width: 100%;
    margin-left: 0;
    margin-top: 80px;
  }
}
@media only screen and (min-width: 0px) and (max-width: 767px) {
  .atp-video-container video {
    border-radius: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/IntroVideo/IntroVideo.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AAAI;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EAEA,iBAAA;AAEN;AACI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;AACN;AAEI;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AAAN;AAGI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AADN;AAGM;EACE,WAAA;EACA,YAAA;AADR;AAKI;EAEE,aAAA;AAJN;AAOI;EACE,aAAA;AALN;;AAQE;EACE;IACE,iBAAA;IACA,uBAAA;EALJ;AACF;AAOE;EACE;IACE,WAAA;IACA,cAAA;IACA,gBAAA;EALJ;AACF;AAOE;EAEI;IACI,mBAAA;EANR;AACF","sourcesContent":[".atp-video-container{\r\n    width: calc(50% - 35px);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;  \r\n    border-radius: 32px;\r\n    margin-left: 35px;\r\n    position: relative;\r\n    border-radius: 32px;\r\n    overflow: hidden;\r\n    video{\r\n      border-radius: 32px;\r\n      width: 100%;\r\n      height: 100%;\r\n      -o-object-fit: cover;\r\n      object-fit: cover;\r\n    }\r\n    \r\n    .overlay {\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      width: 100%;\r\n      height: 100%;\r\n      background-color: rgba(0, 0, 0, 0.5);\r\n      display: flex;      \r\n    }\r\n\r\n    .video-title{\r\n      color: #fff;\r\n      font-size: 26px;\r\n      font-weight: 300;\r\n      text-align: center;\r\n      width: 100%;\r\n      padding-top: 40px;\r\n    }\r\n  \r\n    .custom-play-button {\r\n      position: absolute;\r\n      top: 50%;\r\n      left: 50%;\r\n      transform: translate(-50%, -50%);\r\n      cursor: pointer;\r\n      border: none;\r\n      background: none;\r\n      outline: none;\r\n  \r\n      img {\r\n        width: 50px; \r\n        height: auto;\r\n      }\r\n    }\r\n  \r\n    &.playing .overlay,\r\n    &.playing .custom-play-button {\r\n      display: none;\r\n    }\r\n  \r\n    .hidden {\r\n      display: none;\r\n    }\r\n  }\r\n  @media only screen and (min-width: 0px) and (max-width: 1024px) {\r\n    .atp-video-container{\r\n      margin-left: 16px;\r\n      width: calc(50% - 16px);\r\n    }\r\n  }\r\n  @media only screen and (min-width: 0px) and (max-width: 768px) { \r\n    .atp-video-container{\r\n      width: 100%;\r\n      margin-left: 0;\r\n      margin-top: 80px;\r\n    }\r\n  }\r\n  @media only screen and (min-width: 0px) and (max-width: 767px) {\r\n    .atp-video-container{\r\n      video{\r\n          border-radius: 16px;\r\n      }\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
